import { createClient } from '@supabase/supabase-js';

/*
  Single function. Every component that collects an email calls THIS,
  never the Supabase client directly. If we ever switch backends again,
  this is the only file that changes.
*/

const SUPABASE_URL = 'https://dgztnhomowsdmaozekhf.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRnenRuaG9tb3dzZG1hb3pla2hmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODU3MzMxNjEsImV4cCI6MjEwMTMwOTE2MX0._kVz4n8JInG_RivYLHpH7HFs78RuI57EpiaccrHYjI4';

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// Postgres unique_violation error code - fires when subscribers_email_unique
// constraint rejects a duplicate email. Distinct from a real failure: we
// want the caller to show "you're already on the list", not a generic error.
const UNIQUE_VIOLATION = '23505';

export async function submitEmail({ email, source, optIn = true }) {
  if (!email || !email.includes('@')) {
    return { ok: false, error: 'Invalid email address.' };
  }

  const { error } = await supabase
    .from('subscribers')
    .insert([{ email, source, opt_in: optIn }]);

  if (error) {
    if (error.code === UNIQUE_VIOLATION) {
      return { ok: false, alreadyExists: true };
    }
    console.error('submitEmail failed:', error);
    return { ok: false, error: 'Something went wrong. Please try again.' };
  }

  return { ok: true };
}
